export default __webpack_public_path__ + "static/media/fruces-breakfast.bfcfa65a.jpg";